import { render, staticRenderFns } from "./ZalTypeList.vue?vue&type=template&id=e049c16c&"
import script from "./ZalTypeList.vue?vue&type=script&lang=js&"
export * from "./ZalTypeList.vue?vue&type=script&lang=js&"
import style0 from "./ZalTypeList.vue?vue&type=style&index=0&id=e049c16c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports